import AnimatedNumber from 'animated-number-react';
import React from 'react';
import ReactTooltip from 'react-tooltip';

import { setColor, getMoodName } from '../../utils/colors';
import { colors } from '../../styles';

import { useStyles } from './styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
// import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardContent';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';

interface IProps {
  data?: any;
  float?: boolean;
  image?: string;
  icon?: React.ReactNode;
  outOf?: number;
  title: string;
  change?: number;
  additional?: string;
  additionalTitle?: string;
  share?: number;
  rt?: boolean;
  withoutIcon?: boolean;
  withoutChip?: boolean;
  withoutTime?: boolean;
  post?: string;
}

const ActivityCard: React.FC<IProps> = React.memo(
  ({
    data,
    float,
    icon,
    title,
    outOf,
    change,
    additional,
    additionalTitle,
    rt,
    share,
    withoutIcon,
    withoutChip,
    withoutTime,
    post,
  }) => {
    const classes = useStyles();

    const formatValue = !float
      ? (value: number) => value.toFixed(0)
      : (value: number) => value.toFixed(2);

    return (
      <Grid>
        <ReactTooltip multiline={true} />
        <CardHeader style={{ height: '40px' }}>
          <Typography className={classes.titles} component="h2">
            <Grid container spacing={1}>
              {!withoutIcon && (
                <Grid item xs={2}>
                  <span>{icon}</span>
                </Grid>
              )}
              <Grid item xs={10}>
                <span>{title}</span>
              </Grid>
            </Grid>
          </Typography>
        </CardHeader>
        <CardContent
          style={{ height: '100px' }}
          data-tip={
            title.includes('Workspace') || title.includes('Mentions') || title.includes('Sentiment')
              ? ''
              : `If the number to be compared <br /> is smaller than the value,  probably <br /> there are ${
                  title.includes('Members') ? 'members' : 'channels'
                } that were ${title.includes('Members') ? 'deactivated' : 'archived'}.`
          }
        >
          {!float || withoutChip ? (
            <Box className={classes.numberValueHolder}>
              {data && data.currentMood ? (
                <AnimatedNumber
                  className={`${classes.values} no-translate`}
                  value={data.currentMood ? data.currentMood * 100 : 0}
                  formatValue={formatValue}
                />
              ) : (
                <AnimatedNumber
                  className={`${classes.values} no-translate`}
                  value={data ? data : 0}
                  formatValue={formatValue}
                />
              )}
              {post && <span className={classes.outOf}>{post}</span>}
              {outOf && <span className={classes.outOf}>/ {outOf}</span>}
              {change || change === 0 ? (
                <span
                  className={`${classes.outOf} no-translate`}
                  style={
                    change !== 0 ? { color: change >= 0 ? colors.greenBrand : colors.redBrand } : {}
                  }
                >
                  ({change >= 0 ? '+' : ''}
                  {change.toFixed(2)}%)
                </span>
              ) : withoutChip && data.currentMood > data.previousMood ? (
                <TrendingUpIcon className={classes.iconArrow} />
              ) : withoutChip && data.currentMood < data.previousMood ? (
                <TrendingDownIcon className={classes.iconArrow} />
              ) : withoutChip && !post ? (
                <TrendingFlatIcon className={classes.iconArrow} />
              ) : null}
              {share || share === 0 ? (
                <span className={`${classes.outOf} no-translate`}>({share.toFixed(1)}%)</span>
              ) : null}
              {additional && !withoutTime ? (
                <Grid className={classes.additional}>
                  <span className={classes.outOf}>{additionalTitle}</span>
                  <span className={classes.additionalText}>{`${additional}`}</span>
                </Grid>
              ) : null}
            </Box>
          ) : (
            <Paper
              elevation={0}
              style={{
                display: 'flex',
                alignItems: 'center',
                background: `${data.currentMood ? setColor(data.currentMood) : setColor(data)}`,
                height: '80%',
                marginTop: '5px',
              }}
            >
              <Typography variant="h6" className={classes.typography}>
                {getMoodName(!rt ? data.currentMood : data)}
                {!rt ? (
                  data.currentMood > data.previousMood ? (
                    <TrendingUpIcon className={classes.iconArrow} />
                  ) : data.currentMood < data.previousMood ? (
                    <TrendingDownIcon className={classes.iconArrow} />
                  ) : (
                    <TrendingFlatIcon className={classes.iconArrow} />
                  )
                ) : null}
              </Typography>
            </Paper>
          )}
        </CardContent>
      </Grid>
    );
  }
);

ActivityCard.displayName = 'ActivityCard';

export { ActivityCard };
